<template>
  <div class="home bg-white w-full p-4 py-6">
    <h1 class="font-semibold text-center text-xl">
      Konfirmasi identitas anda terlebih dahulu, untuk melihat hasil pemeriksaan!
    </h1>
    <div class="mt-20">
      <label class="text-sm">Tanggal Lahir</label>
      <VueDatePicker
        v-model="date"
        :max-date="new Date()"
        auto-apply
        :enable-time-picker="false"
        placeholder="Hari/Bulan/Tahun"
        format="dd/MM/yyyy"
        hide-input-icon
        class="my-2"
        :class="dateEmpty ? 'custom-datepicker-empty' : 'custom-datepicker'"
      />
      <p class="text-red-500 text-right text-sm" :class="dateEmpty ? 'opacity-1' : 'opacity-0'">Untuk melanjutkan, tambahkan informasi terlebih dahulu!</p>
    </div>
    <BaseButton class="mt-20" @onClick="nextClicked">
      <template #text>
        Lanjutkan
      </template>
    </BaseButton>
    <BasicModal v-show="successConfirmed">
      <template #modal-body>
        <div class="modal-body">
          <div class="modal-content">
            <img src="@/assets/img/confirm-success.png" alt="Success" class="w-[49%] m-auto mt-5">
            <h2 class="text-xl font-semibold text-center my-5">Konfirmasi identitas anda telah berhasil</h2>
          </div>
          <div class="modal-button">
            <router-link :to="`/result?token=${encodeURIComponent(route.query.token)}`">
              <BaseButton>
                <template #text>
                  Lihat Hasil Pemeriksaan
                </template>
              </BaseButton>
            </router-link>
          </div>
        </div>
      </template>
    </BasicModal>
    <BasicModal v-show="failedConfirmed">
      <template #modal-body>
        <div class="modal-body">
          <div class="modal-content">
            <img src="@/assets/img/confirm-failed.png" alt="Success" class="w-[49%] m-auto mt-5">
            <h2 class="text-xl font-semibold text-center my-5">Informasi yang anda berikan tidak sesuai!</h2>
            <p class="text-sm text-center my-5">Coba periksa dan masukkan kembali tanggal lahir Anda, atau hubungi kader untuk informasi lebih lanjut.</p>
          </div>
          <div class="modal-button">
            <BaseButton @onClick="failedConfirmed = false">
              <template #text>
                Coba Lagi
              </template>
            </BaseButton>
          </div>
        </div>
      </template>
    </BasicModal>
    <Loading v-show="loading" class="top-0 left-0 bg-[rgba(0,0,0,0.25)]"/>
  </div>
</template>

<script setup>
import {
  ref, watch, computed,
} from 'vue';

import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import { formatISOToDate } from '@/utilities/helpers';

import BaseButton from '@/components/buttons/BaseButton.vue';
import BasicModal from '@/components/modals/BasicModal.vue';
import Loading from '@/components/LoadingOverlay.vue';

// const emit = defineEmits(['buyGold', 'completeProfile'])
const route = useRoute();
const store = useStore();
const date = ref(null);
const dateEmpty = ref(false);
const successConfirmed = ref(false);
const failedConfirmed = ref(false);

const loading = computed(() => {
  const loadingGlobal = store.state.global.loading;
  return loadingGlobal;
});

// // eslint-disable-next-line no-unused-vars
// const screeningData = computed(() => {
//   const screening = store.state.screening.screeningData;
//   return screening;
// });

watch(date, (val) => {
  if (val) {
    dateEmpty.value = false;
  } else {
    dateEmpty.value = true;
  }
});

async function nextClicked() {
  if (date.value) {
    const res = await getScreeningData();
    if (res === true) {
      successConfirmed.value = true;
      localStorage.setItem(encodeURIComponent(route.query.token), JSON.stringify([formatISOToDate(date.value), route.query.name]));
      store.dispatch('global/setDob', formatISOToDate(date.value), { root: true });
      store.dispatch('global/setName', route.query.name, { root: true });
    } else if (res === false) {
      failedConfirmed.value = true;
    }
  } else {
    dateEmpty.value = true;
  }
}

async function getScreeningData() {
  const res = await store.dispatch('screening/getScreeningData', {
    token: route.query.token,
    dob: formatISOToDate(date.value),
  });
  return res;
}
</script>

<script>
export default {
  name: 'HomePageView',
};
</script>

<style lang="scss">
.custom-datepicker {
  .dp__input {
    padding: 16px !important;
    border-radius: 8px !important
  }
}

.custom-datepicker-empty {
  .dp__input {
    padding: 16px !important;
    border: 1px solid #f05252 !important;
    border-radius: 8px !important;
  }
}
</style>
